import {
  ErrorOutline as DebtIcon,
  VerifiedOutlined as SuccessIcon
} from '@mui/icons-material';

interface DebtStatusProps {
  hasDebt: boolean;
  nonReportedCount: number;
}

const DebtStatus = ({ hasDebt, nonReportedCount }: DebtStatusProps) => {
  return (
    <div className='flex items-center gap-5'>
      <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${hasDebt ? 'bg-red-50' : 'bg-green-50'}`}>
        {hasDebt ? (
          <DebtIcon className='text-red-500 text-[26px]' />
        ) : (
          <SuccessIcon className='text-green-500 text-[26px]' />
        )}
      </div>
      
      <div className='flex flex-col justify-center translate-y-[-2px]'>
        <span className='text-[10px] font-black text-gray-400 uppercase tracking-[0.15em] mb-1'>
          Estado de Deuda
        </span>
        <p className='text-2xl text-gray-800 leading-none'>
          {hasDebt ? (
            <>El conductor debe <span className='font-black text-red-600'>{nonReportedCount}</span> {nonReportedCount === 1 ? 'pedido' : 'pedidos'}</>
          ) : (
            <>El conductor <span className='font-black text-green-600'>no debe</span> ningún pedido</>
          )}
        </p>
      </div>
    </div>
  );
};

export default DebtStatus;
